module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/acuerdo/acuerdo.component.scss
// module id = ./src/app/acuerdo/acuerdo.component.scss
// module chunks = main